// src/avatar/defaultAvatar.js

export const defaultAvatar = {
  heightCm: 164,

  bodyFat: 0.0, // 0 → +1
  muscle: 0.3, // 0 → 1
  posture: 0.0,

  shoulderWidth: 0.0, // 0 → +1
  bustVolume: 0.0, // 0 → +1
  waistDefinition: 0.0, // 0 → +1
  hipWidth: 0.0, // 0 → +1

  bodyType: {
    pear: 0.25,
    rectangle: 0.25,
    apple: 0.25,
    hourglass: 0.25,
  },

  // --- Morph targets / shape keys (0..1) ---
  Arm_up: 0,
  Bust_up: 0,
  Waist_up: 0,
  Hip_up: 0,
  Leg_up: 0,
};
